import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { UserContext } from "../../App";
import getFirstAllowedRoute from "../../Utlis/GetFirstAllowedRoute";
import Select from "../../Pages/Public/Select";
import VendorDashboard from "../../Pages/FuelVendor/Dashboard";
import VendorTransactionDetail from "../../Pages/FuelVendor/Transactions/TransactionDetail";
import FuelDispensed from "../../Pages/FuelVendor/FuelDispensed";
import FuelPricing from "../../Pages/FuelVendor/FuelPricing";
import AuditTrailVendor from "../../Pages/FuelVendor/AuditTrail";
import MyProfilePage from "../../Pages/FuelVendor/MyProfile";
import EditProfile from "../../Pages/FuelVendor/VendorDetail";
import StaffManagement from "../../Pages/FuelVendor/StaffManagement";
import StaffDetails from "../../Pages/FuelVendor/StaffManagement/StaffDetails";
import SettingsPermissions from "../../Pages/FuelVendor/SettingsPermissions";
import Settlement from "../../Pages/FuelVendor/Settlement";
import Transactions from "../../Pages/FuelVendor/Transactions/index";
import RequestAdjustments from "../../Pages/FuelVendor/Transactions/RequestAdjustments";
import TransactionAdjustmentsDetail from "../../Pages/FuelVendor/Transactions/TransactionAdjustmentsDetail";

const FuelVendorRoutes = ({ setUser }) => {
  const { userData } = useContext(UserContext);
  const fallbackRoute = getFirstAllowedRoute(
    "vendor",
    userData?.page_access,
    "/dashboard-vendor",
  );

  const guard = (slug, redirectTo, element) => {
    const access = userData?.page_access?.[slug];
    const canEdit =
      access === undefined || access === null || access === "view_edit";
    return canEdit ? element : <Navigate to={redirectTo} replace />;
  };

  return (
    <Routes>
      <Route path="/dashboard-vendor" element={<VendorDashboard />} />

      <Route path="/transactions-vendor" element={<Transactions />} />
      <Route
        path="/transaction-detail-vendor"
        element={<VendorTransactionDetail />}
      />
      <Route
        path="transaction-adjustments-detail"
        element={<TransactionAdjustmentsDetail />}
      />

      <Route
        path="/request-adjustments"
        element={guard("transactions", "/transactions-vendor", <RequestAdjustments />)}
      />

      <Route path="/settlement" element={<Settlement />} />

      <Route path="/fuel-pricing" element={<FuelPricing />} />
      <Route path="/fuel-dispensed" element={<FuelDispensed />} />
      <Route path="/audit-trail-vendor" element={<AuditTrailVendor />} />

      <Route path="/staff-management" element={<StaffManagement />} />
      <Route path="/staff-detail" element={<StaffDetails />} />
      <Route
        path="/settings-permissions-vendor"
        element={<SettingsPermissions />}
      />

      <Route
        path="/profile-vendor"
        element={<MyProfilePage setUser={setUser} />}
      />
      <Route path="/vendor-details" element={<EditProfile />} />
      <Route path="/selection" element={<Select setUser={setUser} />} />
      <Route path="*" element={<Navigate to={fallbackRoute} />} />
    </Routes>
  );
};

export default FuelVendorRoutes;
